var render = function render(_c,_vm){return _c('font-awesome-icon',{staticClass:"v-icon",class:{ 'v-icon--position-right': _vm.props.positionRight, 'v-icon--position-left': _vm.props.positionLeft },style:({ fontSize: `${_vm.props.fontSize}em`, color: `${_vm.props.color}` }),attrs:{"size":_vm.props.size,"icon":_vm.props.icon}})
}
var staticRenderFns = []

export { render, staticRenderFns }